export const tokenKeyName = 'jwt';

/**
 * The token as storage holds it **now**.
 *
 * This used to be a constant, `jwtTokenLocalStorage`, read once when the module was first
 * imported. A worker who arrives from a magic link has no token at that moment: it is written a
 * second later by the login screen. For the rest of that page's life the constant said "no
 * token", and any `initialize()` called without an argument treated a signed-in worker as signed
 * out and deleted the token (see the login bounce of 30/09/2026 in `auth-guard.tsx`).
 */
export const readStoredToken = (): string | null => {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem(tokenKeyName) : null;
  } catch {
    // Storage can be unavailable (privacy modes, sandboxed frames): that is "no token", not a crash.
    return null;
  }
};
